export default __webpack_public_path__ + "static/vitalii-kulchytskii-52b43566a88b2f1001bddeda60aca92a.png";